// @vendor
import { createSelector } from 'reselect'

// @utilities
const { getDevicesKey, getIsFetchingKey } = require('utilities/devices');


const getHasForgottenDevices = (state) =>
    (state.devices.get("forgottenDevices")).size ||
    (state.devices.get("forgottenDevicesBlocked")).size ||
    (state.devices.get("forgottenDevicesUnknown")).size

const getIsFetching = (state, blocked, forgotten) => {
    const key = getIsFetchingKey(blocked, forgotten)
    return state.devices.get(key)
}

const getDevices = (state, blocked, forgotten, unknown) => {
    const key = getDevicesKey(blocked, forgotten, unknown)
    return state.devices.get(key)
}

const getIsFetchingDevicesByKey = createSelector(
    [ getIsFetching ],
    (isFetching) => isFetching
);

const getDevicesByKey = createSelector(
    [ getDevices ],
    (devices) => devices
);

const hasForgottenDevices = createSelector(
    [ getHasForgottenDevices ],
    (hasDevices) => hasDevices
);

export {
    getDevicesByKey,
    getIsFetchingDevicesByKey,
    hasForgottenDevices
};
